import React from 'react';
import { AlertCircle, Pencil } from 'lucide-react';

import { PackagingPOStatusCell } from 'components/packaging/components/packagingPOV2/PackagingPOStatusCell';
import { Button } from 'shadcn/components/ui/Button';

/**
 * @param {Object} props
 * @param {Object} [props.order]
 * @param {string|number} [props.orderId]
 * @param {boolean} [props.isEditing=false]
 * @param {boolean} [props.isSaving=false]
 * @param {boolean} [props.isSaveDisabled=false]
 * @param {boolean} [props.hasValidationErrors=false]
 * @param {() => void} [props.onCancel]
 * @param {() => void} [props.onEdit]
 * @param {() => void} [props.onSave]
 * @param {string} [props.editDisabledReason]
 */
export function CrossDockPurchaseOrderEntityHeaderContent({
    editDisabledReason = '',
    hasValidationErrors = false,
    isEditing = false,
    isSaveDisabled = false,
    isSaving = false,
    onCancel,
    onEdit,
    onSave,
    order = null,
    orderId,
}) {
    const saveDisabled = isSaveDisabled || hasValidationErrors;

    return (
        <div className="flex w-full flex-wrap items-start gap-3 lg:items-center">
            <div className="flex flex-wrap items-center gap-3">
                <h1 className="text-2xl font-semibold tracking-tight text-foreground">
                    Cross Dock Purchase Order {orderId ?? order?.id}
                </h1>
                <PackagingPOStatusCell status={order?.status} />
            </div>
            <div className="ml-auto flex shrink-0 items-center gap-2">
                {isEditing ? (
                    <>
                        <Button type="button" variant="outline" size="sm" onClick={onCancel} disabled={isSaving}>
                            Cancel
                        </Button>
                        <Button
                            type="button"
                            variant="default"
                            size="sm"
                            onClick={onSave}
                            disabled={saveDisabled}
                            title={hasValidationErrors ? 'Fix validation errors to save' : undefined}
                        >
                            {isSaving ? (
                                'Saving…'
                            ) : (
                                <>
                                    {hasValidationErrors ? (
                                        <AlertCircle className="mr-2 h-4 w-4 text-destructive" aria-hidden="true" />
                                    ) : null}
                                    Save Changes
                                </>
                            )}
                        </Button>
                    </>
                ) : (
                    <Button
                        type="button"
                        variant="outline"
                        size="sm"
                        onClick={onEdit}
                        disabled={typeof onEdit !== 'function'}
                        title={editDisabledReason || undefined}
                    >
                        <Pencil className="mr-2 h-4 w-4" aria-hidden="true" />
                        Edit
                    </Button>
                )}
            </div>
        </div>
    );
}

CrossDockPurchaseOrderEntityHeaderContent.displayName = 'CrossDockPurchaseOrderEntityHeaderContent';
